import { render, staticRenderFns } from "./coreProductInfoPhone.vue?vue&type=template&id=483acf7b&scoped=true"
import script from "./coreProductInfoPhone.vue?vue&type=script&lang=js"
export * from "./coreProductInfoPhone.vue?vue&type=script&lang=js"
import style0 from "./coreProductInfoPhone.vue?vue&type=style&index=0&id=483acf7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483acf7b",
  null
  
)

export default component.exports